export default "__VITE_ASSET__BCbmNbwc__"